export default __webpack_public_path__ + "static/media/avatar-placeholder.bca964ad.jpg";